import './quoteblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {LinkType, WysiwygType} from 'types'
import {PageLink} from 'util/pagelink'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'
import {Theme} from 'views/theme'

const styles = style('quoteblock')

export type QuoteBlockType = {
	quote: WysiwygType
	person?: string
	function?: string
	link?: LinkType
	link_target?: Array<'blank' | 'self' | ''>
}

export const QuoteBlock: FunctionComponent<QuoteBlockType> = ({
	quote,
	person,
	function: func,
	link,
	link_target
}) => {
	if (!quote) return null

	let target = link && link.target ? link.target : '_self'
	if (link_target && link_target.length > 0 && link_target[0] !== '') {
		target = link_target[0] === 'blank' ? '_blank' : '_self'
	}

	return (
		<Block class={styles}>
			<div class={styles('container')}>
				{quote && (
					<div class={styles('quote')}>
						<Theme.Wysiwyg>{quote}</Theme.Wysiwyg>
					</div>
				)}
				{(person || func) && (
					<div class={styles('info')}>
						{person && <span class={styles('info-person')}>{person}</span>}
						{person && func && <span> - </span>}
						{func && <span class={styles('info-function')}>{func}</span>}
					</div>
				)}
				{!!link && (
					<div class={styles('info')}>
						<Theme.Link to={link.url} target={target}>
							{link.description || link.title}
						</Theme.Link>
					</div>
				)}
				<div class={styles('quote-icon')}>“</div>
			</div>
		</Block>
	)
}
